/* JESOU(R) Collection - interacciones de la landing. Vanilla, sin dependencias. */
(function () {
  var d = document, root = d.documentElement;
  root.classList.add('js-jesou');

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function ready(fn) {
    if (d.readyState !== 'loading') { fn(); } else { d.addEventListener('DOMContentLoaded', fn); }
  }

  ready(function () {
    /* 1. Anclas temporales para secciones aun sin redisenar (se retiran en fase 2) */
    [['.jesou-detalles', 'jesou-detalles'], ['.jesou-regalo', 'jesou-regalo']].forEach(function (p) {
      var el = d.querySelector(p[0]);
      if (el && !el.id) { el.id = p[1]; }
    });

    /* 2. Ocultar enlaces de navegacion cuyo destino todavia no existe */
    Array.prototype.forEach.call(d.querySelectorAll('.jesou-hd__nav a[href^="#"]'), function (a) {
      var h = a.getAttribute('href');
      if (h && h !== '#' && !d.querySelector(h)) { a.hidden = true; }
    });

    /* 3. Revelado suave al entrar en pantalla */
    var items = d.querySelectorAll('.jesou-reveal');
    if (reduce || !('IntersectionObserver' in window)) {
      Array.prototype.forEach.call(items, function (el) { el.classList.add('is-in'); });
    } else {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
        });
      }, { rootMargin: '0px 0px -10% 0px', threshold: 0.08 });
      Array.prototype.forEach.call(items, function (el) { io.observe(el); });
    }

    /* 4. Header al hacer scroll + parallax del hero (solo escritorio) */
    var hd = d.querySelector('.jesou-hd');
    var heroImg = d.querySelector('.jesou-hero__media img');
    var parallax = heroImg && !reduce && window.innerWidth > 1000;
    var ticking = false;

    if (parallax) { heroImg.style.transform = 'scale(1.07)'; }

    function onScroll() {
      if (ticking) { return; }
      ticking = true;
      window.requestAnimationFrame(function () {
        var y = window.pageYOffset || root.scrollTop || 0;
        if (hd) {
          if (y > 60) { hd.classList.add('is-scrolled'); } else { hd.classList.remove('is-scrolled'); }
        }
        if (parallax && y < window.innerHeight * 1.3) {
          heroImg.style.transform = 'translate3d(0,' + (y * 0.06).toFixed(1) + 'px,0) scale(1.07)';
        }
        ticking = false;
      });
    }

    if (hd || parallax) {
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    }
  });
})();
